export default "__VITE_ASSET__DLQNQ4ci__"